{
  "calendar.eyebrow": "Overview",
  "calendar.description": "Meetings, calls and viewings for you and your team. Click any day or hour to plan something.",
  "calendar.view.month": "Month",
  "calendar.view.week": "Week",
  "calendar.view.agenda": "Agenda",
  "calendar.more": "+{count} more",
  "calendar.newOn": "Plan something on {day}",
  "calendar.edit": "Edit event",
  "calendar.created": "Event added to the calendar.",
  "calendar.deleted": "Event deleted.",
  "calendar.field.title": "Title",
  "calendar.field.activity": "Kind",
  "calendar.field.startDate": "Starts",
  "calendar.field.startTime": "At",
  "calendar.field.endDate": "Ends",
  "calendar.field.endTime": "At",
  "calendar.field.description": "Details",
  "calendar.field.with": "With",
  "calendar.activity.Meeting": "Meeting",
  "calendar.activity.Call": "Call",
  "calendar.activity.Viewing": "Viewing",
  "calendar.activity.Follow-up": "Follow-up",
  "calendar.empty.title": "A clear month",
  "calendar.empty.body": "Nothing planned yet. Schedule viewings and calls from a client's profile or right here."
}
